import React, { useState } from "react";
import "./modal.css";
import { Modal } from "react-bootstrap";

const Alertmodal = ({ open, handleClose }) => {
  return (
    <Modal
      size="sm"
      show={open}
      //onHide={handleClose}
      animation={true}
      className="custom-modal alert-modal"
      centered
    >
      <p
        className="text-center"
        style={{
          fontWeight: "600",
        }}
      >
        {open}
      </p>
      <div className="d-flex align-items-center justify-content-center ">
        <button
          onClick={() => {
            handleClose();
          }}
          className="action-button-previous"
          style={{
            background: "#50a1a4",
            border: "none",
            color: "#fff",
            fontSize: "15px",
            padding: "6px 12px",
          }}
        >
          Okay
        </button>
      </div>
    </Modal>
  );
};

export default Alertmodal;
